<ng-container [formGroup]="configurationCellFormGroup">
    <mat-form-field fxFlex.sm="100" fxFlex.xs="100" fxFlex.gt-sm="50" *ngIf="isEditable">
        <mat-label>Configuration</mat-label>
        <mat-select [formControl]="configurationFormControl" (selectionChange)="configurationChanged($event)">
            <mat-option *ngFor="let configuration of item.configurations" [value]="configuration.id">
                {{ configuration | deviceConfiguration }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <span *ngIf="!isEditable && item.configuration">
        {{ item.configuration.Value }}
    </span>
</ng-container>